import 'intersection-observer';

import { accordion } from './accordion/accordion';
import { collapsable } from './collapsable/collapsable';
import { comment } from './comment/comment';
import { cookieBar } from './cookie-bar/cookieBar';
import { fancySelect } from './fancy-select/fancySelect';
import { form } from './form/form';
import {slider} from "./slider/slider";
import { ytVideo } from "./yt-video/ytVideo";
import { backgroundParallax } from "./background-parallax/backgroundParallax";
import { audioplayer } from "./audioplayer/AudioPlayer";
import { trigger } from "./modal/trigger";
import { focusTrigger } from "./focus-trigger/focusTrigger";
import { documentLink } from "./document-link/documentLink";
import {menu} from "./menu/menu";

window.addEventListener('DOMContentLoaded', (): void => {
    cookieBar();
    accordion();
    form();
    collapsable();
    fancySelect();
    comment();
    slider();
    ytVideo();
    slider();
    backgroundParallax();
    audioplayer();
    trigger();
    focusTrigger();
    documentLink();
    menu()
});
